<template>
  <v-dialog v-model="showTable" persistent scrollable max-width="600px">
    <v-card>
      <v-card-title class="pa-0">
        <v-col class="text-end py-0 px-0 pb-0" cols="12">
          <v-btn class="pa-0" icon dark @click="clean()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center pt-0 pb-0" cols="12">
          <h1 style="font-size:24px" class="mb-0 mt-0">Protocolo</h1>
          <span v-if="items.historico != 0 && !isLoteComplementar">
            <button @click="historico = true" v-if="!historico" class="button-histor pa-0">
              <v-icon class="py-0 px-1" color="primary" x-small>far fa-eye</v-icon>
              <b style="font-size:12px;color:#118ACA">Histórico</b>
            </button>
            <button @click="historico = false" v-if="historico" class="button-histor pa-0">
              <v-icon class="py-0 px-1" color="primary" x-small>far fa-eye-slash</v-icon>
              <b style="font-size:12px;color:#118ACA">Histórico</b>
            </button>
            <p v-if="!historico" style="font-size:14px;line-height:18px" class="mb-2">
              Caso necessário, edite o retorno <br> da operadora.
            </p>
          </span>
          <p v-if="items.historico == 0 && !isLoteComplementar || isLoteComplementar && !complementar" style="font-size:14px;line-height:18px" class="mb-2">
            Informe o protocolo e data de transmissão <br> do lote e o retorno da operadora.
          </p>
          <p v-if="isLoteComplementar && complementar" style="font-size:14px;line-height:18px" class="mb-2">
            Informe o protocolo e data de transmissão do lote.
          </p>
        </v-col>
      </v-card-title>
      <v-card-text v-show="historico" class="px-5 pt-0 pb-10">
        <v-data-table dense :headers="headers" :items="items.historico" hide-default-footer>
          <template v-slot:item="props">
            <tr>
              <td class="text-center pa-2">{{ props.item.dt_alteracao | formatDate }}</td>
              <td class="text-center pa-2">{{ props.item.numero }}</td>
              <td class="text-center pa-2">{{ props.item.dt_protocolo | formatDate }}</td>
              <td class="text-left pa-2">{{ getStatus(props.item) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-text v-show="!historico" class="px-10 pt-0 pb-1">
        <v-form ref="protocoloForm" :value="formValid">
          <v-col class="py-0 px-6" cols="12">
            <label>Número</label>
            <v-text-field
              v-model="formData.env_op_protocolo"
              placeholder="Protocolo"
              type="number"
              single-line
              outlined
              dense
              :rules="[formRules.requiredField, formRules.max20]"
            ></v-text-field>
          </v-col>
          <v-col class="py-0 px-6" cols="12">
            <label>Data</label>
            <v-menu
              ref="dtI"
              v-model="dtI"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  dense
                  v-mask="'##/##/####'"
                  format="DD/MM/YYYY"
                  placeholder="DD/MM/YYYY"
                  label
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  @blur="date = parseDate(dateFormatted)"
                  :rules="[formRules.requiredField, formRules.typeDateFormated]"
                ></v-text-field>
              </template>
              <v-date-picker color="primary" 
                v-model="date"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0 px-6" cols="12" v-show="!isLoteComplementar">
            <label>Retorno de operadora</label>
            <v-select
              v-model="formData.env_op_status_protocolo"
              :menu-props="{ bottom: true, offsetY: true }"
              flat
              solo
              dense
              :items="status"
              item-text="descricao"
              item-value="id"
              placeholder="Selecione"
              outlined
              :rules="formRules.required"
            ></v-select>
          </v-col>
          <v-col v-if="formData.env_op_status_protocolo == '1' || formData.env_op_status_protocolo == '4'" class="py-0 px-6" cols="12">
            <label>Crítica</label>
            <v-textarea 
              outlined
              flat
              solo
              dense
              height="80px"
              :rules="formRules.required"
              placeholder="Erro acusado pela operadora"
              v-model="formData.erro_protocolo"
            ></v-textarea>
          </v-col>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-5 pb-1 pt-0">
        <v-col v-if="!historico" class="text-left px-5 pb-4 pt-0" cols="6">
          <v-btn
            height="30px"
            small
            color="primary"
            depressed
            outlined
            @click="clean()"
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col v-if="!historico" class="text-right px-5 pb-6 pt-0" cols="6">
          <v-btn
            color="primary"
            height="30px"
            small
            depressed
            @click="save()"
          >
            Salvar
          </v-btn>
        </v-col>
        <v-col v-if="historico" class="text-center px-5 pb-6 pt-0" cols="12">
          <v-btn
            color="primary"
            height="30px"
            small
            depressed
            @click="historico = false"
          >
            Voltar
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex"
import moment from 'moment'
export default {
  components: {},
  data() {
    return {
      formData: {
        env_op_protocolo: null,
        env_op_dt_protocolo: null,
        env_op_status_protocolo: null,
        erro_protocolo: null,
        dt_alteracao: null
      },
      showTable: false,
      dateFormatted: null,
      date: null,
      dtI: false,
      status:[
        // {id: "0" , descricao: 'Aguardando retorno'},
        {id: "3" , descricao: 'Aceito'},
        // {id: "1" , descricao: 'Aceito parcialmente'},
        {id: "4" , descricao: 'Rejeitado'}
      ],
      statusList: {
        0: 'Aguardando retorno',
        3: 'Aceito',
        1: 'Aceito parcialmente',
        4: 'Rejeitado'
      },
      formValid: true,
      acao: null,
      historico: false,
      headers: [
        { text: "Atualizado em:", align: "left", value: "dt_alteracao", sortable: false },
        { text: "Protocolo", align: "start", value: "numero", sortable: false },
        { text: "Data protocolo", value: "dt_protocolo", sortable: false },
        { text: "Retorno da oper.", value: "status", sortable: false }
      ],
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  watch: {
    dialog(val) {
      this.showTable = val
      this.historico = false
      if(val) {
        this.validations()
      } else {
        this.clean();
      }
    },
    dateFormatted(val) {
      this.formData.env_op_dt_protocolo = this.parseDate(val);
    },
    date(val) { 
      this.dateFormatted = this.formatDate(val);
    },
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    validations() {
      if (this.items.env_op_protocolo != null) {
        this.acao = "updateprotocolo"
        this.formData.env_op_status_protocolo = this.isLoteComplementar? '3' : null
        this.formData.dt_alteracao = this.items.dt_alteracao
        this.formData.env_op_protocolo = this.isLoteComplementar? this.items.env_op_protocolo : null
        this.date = this.isLoteComplementar? this.items.env_op_dt_protocolo : null
      } else {
        this.formData.env_op_status_protocolo = this.isLoteComplementar? '3' : null
        this.acao = "addprotocolo"
      }
    },
    clean() {
      this.formData = {
        env_op_protocolo: null,
        env_op_dt_protocolo: null,
        env_op_status_protocolo: null,
        erro_protocolo: null,
        dt_alteracao: null
      },
      this.dateFormatted = null
      this.date = moment().format("YYYY-MM-DD")
      setTimeout(() => {this.date = null},10)
      this.acao = null
      this.$refs.protocoloForm.resetValidation()
      this.showClose(false)
    },
    getStatus(item){
      if(item.status != 3){
        return this.statusList[item.status]
      } else {
        return item.critica !=null? this.statusList[1] : this.statusList[item.status]
      }
    },
    save() {
      if (this.$refs.protocoloForm.validate()) {
        let status = this.formData.env_op_status_protocolo
        if(status != '1' && status != '4'){
          this.formData.erro_protocolo = null
        }
        this.formData.env_op_status_protocolo = status == '1'? '3' : status
        this.sendForm(this.formData, this.acao)
        this.clean()
      }
    }
  },
  props: {
    dialog: Boolean,
    showClose: Function,
    items: Object,
    sendForm: Function,
    isLoteComplementar: Boolean,
    complementar: Boolean
  },
};
</script>

<style>
.button-histor:focus {
  outline: none;
}
</style>